import React, { useState } from 'react';
import axios from 'axios';
import './App.css'; // Import your CSS for styling
import Footer from './Footer'; // Import the Footer component

const ChatApp = () => {
  const [conversation, setConversation] = useState([]); // For storing chat history
  //const [finalText, setFinalText] = useState(''); // For storing the final text
  const [interimText, setInterimText] = useState(''); // For storing the interim text
  const [isListening, setIsListening] = useState(false); // To control listening state
  const [context, setContext] = useState(''); // For storing project context

  // Initialize the SpeechRecognition API
  const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
  
  // Event handlers for speech recognition
  recognition.onstart = () => {
    setIsListening(true);
    console.log('Listening...');
  };

  recognition.onresult = async (event) => {
    // Capture the interim result
    const interimTranscript = event.results[0][0].transcript; 
    setInterimText(interimTranscript); // Update interim text state

    // Check if the result is final
    if (event.results[0].isFinal) {
      //setFinalText(interimTranscript); // Update final text state
      await handleChatGptQuery(interimTranscript); // Call ChatGPT with final text
      setInterimText(''); // Clear interim text after processing final text
    }
    
    // Continue listening after processing the result
    recognition.start();
  };

  recognition.onend = () => {
    // Do not stop listening; we'll control it manually
    console.log('Stopped listening, but will restart.');
  };

  // Function to handle sending messages to ChatGPT
  const handleChatGptQuery = async (message) => {
    if (!message) return; // Don't call if there's no message

    // Update conversation with user's final message
    setConversation(prev => [...prev, { role: 'user', content: message }]);

    // Create a message that includes context
    const fullMessage = `Context: ${context}\nUser: ${message}`;

    try {
      const response = await axios.post('https://api.voicem8.com/chatgpt', { message: fullMessage });

      // Add ChatGPT's response to conversation
      setConversation(prev => [...prev, { role: 'assistant', content: response.data.response }]);
    } catch (error) {
      console.error("Error fetching response from ChatGPT:", error);
    }
  };

  // Function to handle setting context
  const handleContextSubmit = (e) => {
    e.preventDefault();
    setContext(e.target.elements.contextInput.value);
    alert('Context Done');
  };

  // Function to start recognition
  const startListening = () => {
    //setFinalText(''); // Reset final text
    setInterimText(''); // Reset interim text
    recognition.start();
  };

  // Function to stop recognition
  const stopListening = () => {
    recognition.stop();
    setIsListening(false); // Update listening state
  };

  // Render chat history
  return (
    <div className="chat-container">
      <form onSubmit={handleContextSubmit}>
        <textarea name="contextInput" placeholder="Brief about your technology and current project for Interview." rows="3" required />
        <button type="submit">Set Context</button>
      </form>

      <div className="chat-window">
        {conversation.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.role}`}>
            <strong>{msg.role === 'user' ? 'You' : 'Response'}:</strong> {msg.content}
          </div>
        ))}
      </div>
      
      <div className="controls">
        <button onClick={startListening} disabled={isListening}>Ask Anything</button>
        <button onClick={stopListening} disabled={!isListening}>Stop Listening</button>
      </div>

      <div className="interim-text">
        <h3>Live Transcript:</h3>
        <p>{interimText}</p> {/* Display interim text here */}
      </div>
      <Footer /> {/* Include the footer */}
    </div>
  );
};

export default ChatApp;